import jwt_decode from 'jwt-decode';

export const getRealm = () => window.location.hostname.split('.')[0];

export function isAccessTokenExpires(accessToken: string) {
  const data = jwt_decode<{ exp: number }>(accessToken);
  const currentTimeWithoutMilliseconds = Math.floor(Date.now() / 1000);

  return currentTimeWithoutMilliseconds > data.exp;
}
